export class DynamicTable {
	headers: HeaderDynamicTable[];
	registers: RowDynamicTable[];
	title: string;
	filter: any[];
	showFilter: boolean;
	hasActions: boolean;
	hasTotal: boolean;

	constructor() {
		// Generate 20 headers
		this.headers = [];
		this.registers = [];
		this.title = "Tabla dinamica 1";
		this.headers.push(new HeaderDynamicTable(`Nombre`, true, true, false, null, false, "string"));
		this.headers.push(new HeaderDynamicTable(`Cantidad`, true, false, false, null, false, "number"));
		this.headers.push(new HeaderDynamicTable(`Fecha`, true, false, false, null, false, "date"));
		this.headers.push(new HeaderDynamicTable(`Precio`, true, false, false, null, false, "price"));
		this.headers.push(new HeaderDynamicTable(`Oculta`, true, false, true, null, false, "string"));
		this.registers.push(new RowDynamicTable([], ["Willians", 100, "2024/02/28", 5996, "value5"]));
		this.registers.push(new RowDynamicTable([], ["Willians", 100, "2024/02/28", 4004, "value5"]));
		this.registers.push(new RowDynamicTable([], ["Alberto", 54, "2024/11/28", 1896, "value5"]));
		this.registers.push(new RowDynamicTable([], ["Benito", 56, "2024/12/28", 3496, "value5"]));
		this.registers.push(new RowDynamicTable([], ["Marcos", 200, "2024/10/28", 2596, "value5"]));
		this.registers.push(new RowDynamicTable([], ["Lucas", 204, "2024/05/28", 556, "value5"]));
		this.filter = this.registers;
	}
}

export class RowDynamicTable {
	constructor(
		public questions: QuestionDynamicTable[],
		public cells: any[]
	) { }
}

export class QuestionDynamicTable {
	constructor(
		public icon: string,
		public color: string,
		public message: string,
		public background: string
	) { }
}

export class HeaderDynamicTable {
	constructor(
		public title: string,
		public sortable: boolean,
		public groupable: boolean,
		public hidden: boolean,
		public sorted: number,
		public grouped: boolean,
		public type: string
	) { }
}